import { DrawerWrapper } from '@components/ui';
import { Router, navigate } from '@reach/router';
import BidsUpload from 'src/containers/BidsUpload';

import { SidebarRoutePaths } from './constants';
import { BidsTableNextFilter } from './filter/BidsTableNextFilter';
import { useBidsFilter } from './filter/useBidsFilter';
import { getAllExportableColumns } from './lib';
import { ExportColumn, TableColumnDisplaySettings, TableExport } from './table';
import { BidTypes, BidsTableNextInstance } from './types';
import { useBidsExport } from './useBidsExport';

type SidebarProps = {
  table: BidsTableNextInstance;
};

export const BidsPendingTableSidebar = ({ table }: SidebarProps): JSX.Element => {
  const { mutate: exportBids } = useBidsExport();
  const { watch, reset } = useBidsFilter();
  const filterState = watch();
  const results = table.getPageCount();

  const handleSubmitExport = (exportColumns: ExportColumn[]) => {
    const { sorting } = table.getState();
    exportBids({
      filter: filterState,
      sorting,
      exportColumns,
      results,
    });
    navigate(SidebarRoutePaths.pendingFilter);
  };

  return (
    <DrawerWrapper>
      <Router basepath="/" style={{ height: '100%' }}>
        <BidsTableNextFilter
          bidType={BidTypes.Pending}
          // @ts-expect-error
          path={SidebarRoutePaths.pendingFilter}
        />
        <TableColumnDisplaySettings
          table={table}
          columns={table.getAllLeafColumns()}
          bidType={BidTypes.Pending}
          // @ts-expect-error
          path={SidebarRoutePaths.pendingColumnSettings}
        />

        <TableExport
          columns={getAllExportableColumns(table.getAllLeafColumns())}
          onSubmit={handleSubmitExport}
          // @ts-expect-error
          path={SidebarRoutePaths.pendingExport}
        />

        <BidsUpload
          refetchLists={reset}
          // @ts-expect-error
          path={SidebarRoutePaths.pendingUpload}
        />
      </Router>
    </DrawerWrapper>
  );
};
